import { memo } from 'react';
import {
  Circle as _Circle,
  Mask as _Mask,
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg,
} from 'react-native-svg';
import { themed } from './themed';

const Icon = (props) => {
  const { color, size } = props;
  return (
    <_Svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <_Circle cx="20" cy="20" r="20" fill="#F3F4F6" fillOpacity="0.3" />
      <_Path
        d="M16 13L27.1111 20.2222L16 27.4444V13Z"
        fill="black"
        stroke="black"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </_Svg>
  );
};
Icon.displayName = 'VideoPlayIconRegular';
const VideoPlayIconRegular = memo(themed(Icon));
export { VideoPlayIconRegular };
